export default "__VITE_ASSET__8LKZqtJV__"